package io.horion.auth.presentation.ui.pages.register

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleExclamation
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaLock
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.api.models.domain.LoginMethod
import io.horion.auth.di.koinGet
import io.horion.auth.domain.models.AppLanguage.strings
import io.horion.auth.domain.models.Countries
import io.horion.auth.domain.models.LocalStrings
import io.horion.auth.presentation.ui.components.auth.AuthButton
import io.horion.auth.presentation.ui.components.auth.AuthTextField
import io.horion.auth.presentation.ui.components.layouts.PageLayoutData
import io.horion.auth.presentation.ui.pages.navigation.Screen
import io.horion.auth.presentation.ui.styles.AuthContentStyle
import io.horion.auth.presentation.ui.styles.AuthTitleStyle
import io.horion.auth.presentation.ui.styles.PageWrapperStyle
import io.horion.auth.presentation.ui.theme.AuthSpacing
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import io.horion.auth.presentation.viewmodel.AuthViewModel
import io.horion.auth.utils.Validators
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Option
import org.jetbrains.compose.web.dom.Select
import org.jetbrains.compose.web.dom.Text

@InitRoute
fun initRegisterPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(strings.pageTitleRegister))
}

@OptIn(DelicateApi::class)
@Page("/register")
@Layout("io.horion.auth.presentation.ui.components.layouts.PageLayout")
@Composable
fun registerPage() {
    val ctx = rememberPageContext()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    val authViewModel = koinGet<AuthViewModel>()
    val authUiState = authViewModel.uiState
    var passwordConfirm by remember { mutableStateOf("") }
    val strings = LocalStrings.current

    LaunchedEffect(Unit){
        authViewModel.clear()
    }

    LaunchedEffect(authUiState.registerSucceed) {
        if (authUiState.registerSucceed) {
            if (authUiState.email.isNotBlank()){
                authViewModel.onMethodChange(LoginMethod.EMAIL)
            } else {
                authViewModel.onMethodChange(LoginMethod.PHONE)
            }
            authViewModel.verify()
        }
    }

    LaunchedEffect(authUiState.verifySucceed) {
        if (authUiState.verifySucceed) {
            //authViewModel.verify
            ctx.router.navigateTo(Screen.Verify.route)
        }
    }

    Box(
        modifier = PageWrapperStyle.toModifier(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = AuthContentStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally        ) {
            Box(modifier = Modifier.height(AuthSpacing.xl))

            SpanText(
                strings.registerTitle,
                modifier = AuthTitleStyle.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .color(colors.onBackground)
                    .textAlign(TextAlign.Center)
            )
            Box(modifier = Modifier.height(4.px))
            SpanText(
                strings.registerSubtitle,
                modifier = Modifier
                    .fontSize(AuthTypography.small)
                    .color(colors.mutedText)
                    .textAlign(TextAlign.Center)
            )
            Box(modifier = Modifier.height(AuthSpacing.xl))

            if (authUiState.authErrorMessage != null) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(12.px)
                        .borderRadius(8.px)
                        .border(1.px, LineStyle.Solid, colors.error)
                        .styleModifier { property("background-color", "rgba(239,68,68,0.08)") }
                        .gap(8.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FaCircleExclamation(modifier = Modifier.color(colors.error).fontSize(14.px))
                    SpanText(authUiState.authErrorMessage!!, modifier = Modifier.fontSize(AuthTypography.small).color(colors.error))
                }
                Box(modifier = Modifier.height(AuthSpacing.md))
            }


//            Row(
//                modifier = Modifier.fillMaxWidth().margin(bottom = 16.px),
//                horizontalArrangement = Arrangement.SpaceBetween,
//                verticalAlignment = Alignment.CenterVertically
//            ) {
//                SpanText(
//                    if (authUiState.method == LoginMethod.EMAIL) "Par e-mail" else "Par téléphone",
//                    modifier = Modifier.fontSize(AuthTypography.small).fontWeight(FontWeight.Bold).color(colors.onBackground)
//                )
//                SpanText(
//                    if (authUiState.method == LoginMethod.EMAIL) "Utiliser un téléphone" else "Utiliser un e-mail",
//                    modifier = Modifier
//                        .fontSize(AuthTypography.tiny)
//                        .fontWeight(FontWeight.SemiBold)
//                        .color(colors.primary)
//                        .cursor(Cursor.Pointer)
//                        .onClick {
//                            val t = if (authUiState.method == LoginMethod.EMAIL) LoginMethod.PHONE else LoginMethod.EMAIL
//                            authViewModel.onMethodChange(t)
//                        }
//                )
//            }

            EmailPanel(
                viewModel = authViewModel,
                passwordConfirm = passwordConfirm,
                onPasswordConfirmChange = {
                    passwordConfirm = it
                },
                colorMode = colorMode
            )

//            when (authUiState.method) {
//                LoginMethod.EMAIL -> EmailPanel(viewModel = authViewModel, colorMode = colorMode)
//                LoginMethod.PHONE -> PhonePanel(viewModel = authViewModel, colorMode = colorMode)
//            }

            Box(modifier = Modifier.height(AuthSpacing.lg))

            AuthButton(
                text = strings.nextButton,
                onClick = { authViewModel.register() },
                loading = authUiState.isLoading,
                disabled = !authViewModel.isFormValid(passwordConfirm)
            )

            Box(modifier = Modifier.height(AuthSpacing.lg))

            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.Center) {
                SpanText(strings.alreadyHaveAccount, modifier = Modifier.fontSize(AuthTypography.small).color(colors.mutedText))
                SpanText(
                    strings.signInNow,
                    modifier = Modifier
                        .fontSize(AuthTypography.small)
                        .color(colors.primary)
                        .fontWeight(FontWeight.SemiBold)
                        .cursor(Cursor.Pointer)
                        .onClick { ctx.router.navigateTo(Screen.Login.route) }
                )
            }
            Box(modifier = Modifier.height(AuthSpacing.xl))
        }
    }
}

@Composable
private fun EmailPanel(
    viewModel: AuthViewModel,
    passwordConfirm : String,
    onPasswordConfirmChange : (String) -> Unit,
    colorMode: ColorMode
) {
    val colors = AuthTheme.colors(colorMode)
    val uiState = viewModel.uiState

    val password = uiState.password
    val hasMinLength = password.length >= 8
    val hasUpper = password.any { it.isUpperCase() }
    val hasLower = password.any { it.isLowerCase() }
    val hasDigit = password.any { it.isDigit() }
    val hasSpecial = password.any { !it.isLetterOrDigit() }

// Calcul du score de force (0 à 5)
    val validationScore = listOf(hasMinLength, hasUpper, hasLower, hasDigit, hasSpecial).count { it }

    val otpEnabled = uiState.verifySucceed

    val canSendOtp = (uiState.email.isNotBlank() || uiState.phone.isNotBlank())
            && (Validators.isValidEmail(uiState.email) || Validators.isValidPhone(uiState.phone))
            && Validators.isValidPassword(uiState.password)
            && uiState.otpCooldownSeconds == 0

    Column(modifier = Modifier.fillMaxWidth()) {
        // Email
        AuthTextField(
            modifier = Modifier.fillMaxWidth(),
            value = uiState.email,
            onValueChange = { viewModel.onEmailChange(it) },
            placeholder = strings.emailPlaceholder,
            type = InputType.Email,
            leadingIcon = { FaEnvelope(modifier = Modifier.color(colors.secondary)) },
            error = uiState.emailError,
            success = uiState.email.isNotEmpty() && Validators.isValidEmail(uiState.email)
        )
        Box(modifier = Modifier.height(AuthSpacing.sm))

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .borderRadius(12.px)
                .backgroundColor(colors.inputBg)
                .border(2.px, LineStyle.Solid, if (uiState.phoneError != null) colors.error else colors.border),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Select(attrs = {
                onChange { viewModel.onCountryCodeChange(it.value ?: Countries.CMR.code) }
                style {
                    property("height", "48px")
                    property("background", "transparent")
                    property("border", "none")
                    property("border-right", "1.5px solid ${colors.borderLight}")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("font-size", "13px")
                    property("padding", "0 8px")
                    property("cursor", "pointer")
                    property("min-width", "100px")
                }
            }) {
                Countries.entries.forEach { country ->
                    Option(value = country.code, attrs = { if (country.code == uiState.countryCode) selected() }) {
                        Text(country.code)
                    }
                }
            }
            Input(type = InputType.Tel, attrs = {
                value(uiState.phone)
                onInput { viewModel.onPhoneChange(it.value) }
                attr("placeholder", strings.phonePlaceholder)
                style {
                    property("background", "transparent")
                    property("border", "none")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("flex", "1")
                    property("font-size", "14px")
                    property("padding", "0 14px")
                    property("width", "100%")
                    property("height", "48px")
                }
            })
        }
        uiState.phoneError?.let {
            SpanText(it, modifier = Modifier.color(colors.error).fontSize(AuthTypography.tiny).padding(top = 6.px, left = 12.px))
        }

        Box(modifier = Modifier.height(AuthSpacing.sm))

        // Mot de passe
        AuthTextField(
            modifier = Modifier.fillMaxWidth(),
            value = uiState.password,
            onValueChange = { viewModel.onPasswordChange(it) },
            placeholder = strings.passwordHint,
            type = InputType.Password,
            leadingIcon = { FaLock(modifier = Modifier.color(colors.secondary)) },
            error = uiState.passwordError,
            success = password.isNotEmpty() && validationScore == 5
        )

        if (password.isNotEmpty()) {
            val rules = listOf(
                "8 car. min." to hasMinLength,
                "Majuscule" to hasUpper,
                "Minuscule" to hasLower,
                "Chiffre" to hasDigit,
                "Caractère spécial" to hasSpecial
            )

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 8.px, left = 4.px, right = 4.px)
                    .gap(8.px)
            ) {
                // ── 1. BARRE DE FORCE DU MOT DE PASSE ─────────────────────────────
                Row(
                    modifier = Modifier.fillMaxWidth().gap(6.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    repeat(5) { index ->
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .height(4.px)
                                .borderRadius(2.px)
                                .styleModifier {
                                    val activeColor = when {
                                        validationScore <= 2 -> "#ef4444" // Rouge (Faible)
                                        validationScore <= 4 -> "#eab308" // Jaune (Moyen)
                                        else -> "#22c55e"                 // Vert (Fort)
                                    }
                                    property("background-color", if (index < validationScore) activeColor else "#e2e8f0")
                                    property("transition", "background-color 0.3s ease")
                                }
                        )
                    }
                }

                // ── 2. JETONS (CHIPS) DE CRITÈRES DYNAMIQUES ──────────────────────
                Row(
                    modifier = Modifier.fillMaxWidth().styleModifier { property("flex-wrap", "wrap") }.gap(6.px)
                ) {
                    rules.forEach { (label, isMet) ->
                        Row(
                            modifier = Modifier
                                .padding(topBottom = 4.px, leftRight = 8.px)
                                .borderRadius(12.px)
                                .styleModifier {
                                    property("background-color", if (isMet) "rgba(34, 197, 94, 0.1)" else "rgba(241, 245, 249, 0.8)")
                                    property("border", if (isMet) "1px solid rgba(34, 197, 94, 0.3)" else "1px solid #e2e8f0")
                                    property("transition", "all 0.2s ease")
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = if (isMet) "✓ " else "• ",
                                modifier = Modifier
                                    .fontSize(AuthTypography.tiny)
                                    .fontWeight(FontWeight.Bold)
                                    .color(if (isMet) colors.primary else colors.black)
                            )
                            SpanText(
                                text = label,
                                modifier = Modifier
                                    .fontSize(AuthTypography.tiny)
                                    .color(if (isMet) colors.onBackground else colors.black)
                            )
                        }
                    }
                }
            }
        }

        Box(modifier = Modifier.height(AuthSpacing.sm))

        AuthTextField(
            modifier = Modifier.fillMaxWidth(),
            value = passwordConfirm,
            onValueChange = { onPasswordConfirmChange(it) },
            placeholder = strings.passwordConfirmHint,
            type = InputType.Password,
            leadingIcon = { FaLock(modifier = Modifier.color(colors.secondary)) },
            error = uiState.passwordError,
            success = Validators.isValidPassword(uiState.password) && uiState.password == passwordConfirm
        )
        if (passwordConfirm.isNotEmpty() && uiState.passwordError == null) {
            SpanText(
                if (uiState.password == passwordConfirm) "Les mots de passe correspondent" else "Les mots de passe ne correspondent pas",
                modifier = Modifier
                    .fontSize(AuthTypography.tiny)
                    .padding(top = 6.px, left = 12.px)
                    .styleModifier {
                        property("color", if (uiState.password == passwordConfirm) "#22c55e" else "#ef4444")
                    }
            )
        }
        Box(modifier = Modifier.height(AuthSpacing.sm))

    }
}

@Composable
private fun PhonePanel(viewModel: AuthViewModel, colorMode: ColorMode) {
    val colors = AuthTheme.colors(colorMode)
    val uiState = viewModel.uiState

    // OTP actif seulement après envoi
    val otpEnabled = uiState.verifySucceed

    // "Envoyer le code" actif si téléphone valide ET mot de passe rempli ET pas en cooldown
    val canSendOtp = uiState.phone.isNotBlank()
            && Validators.isValidPhone(uiState.phone)
            && Validators.isValidPassword(uiState.password)
            && uiState.otpCooldownSeconds == 0

    Column(modifier = Modifier.fillMaxWidth()) {

        // Téléphone avec sélecteur pays
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .borderRadius(12.px)
                .backgroundColor(colors.inputBg)
                .border(2.px, LineStyle.Solid, if (uiState.phoneError != null) colors.error else colors.border),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Select(attrs = {
                onChange { viewModel.onCountryCodeChange(it.value ?: Countries.CMR.code) }
                style {
                    property("height", "48px")
                    property("background", "transparent")
                    property("border", "none")
                    property("border-right", "1.5px solid ${colors.borderLight}")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("font-size", "13px")
                    property("padding", "0 8px")
                    property("cursor", "pointer")
                    property("min-width", "100px")
                }
            }) {
                Countries.entries.forEach { country ->
                    Option(value = country.code, attrs = { if (country.code== uiState.countryCode) selected() }) {
                        Text(country.code)
                    }
                }
            }
            Input(type = InputType.Tel, attrs = {
                value(uiState.phone)
                onInput { viewModel.onPhoneChange(it.value) }
                attr("placeholder", "Numéro de téléphone")
                style {
                    property("background", "transparent")
                    property("border", "none")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("flex", "1")
                    property("font-size", "14px")
                    property("padding", "0 14px")
                    property("width", "100%")
                    property("height", "48px")
                }
            })
        }
        uiState.phoneError?.let {
            SpanText(it, modifier = Modifier.color(colors.error).fontSize(AuthTypography.tiny).padding(top = 6.px, left = 12.px))
        }

        Box(modifier = Modifier.height(AuthSpacing.sm))

        AuthTextField(
            modifier = Modifier.fillMaxWidth(),
            value = uiState.password,
            onValueChange = { viewModel.onPasswordChange(it) },
            placeholder = "Mot de passe (6 caractères min.)",
            type = InputType.Password,
            leadingIcon = { FaLock(modifier = Modifier.color(colors.secondary)) },
            error = uiState.passwordError
        )

        Box(modifier = Modifier.height(AuthSpacing.sm))

        // Champ OTP + bouton "Envoyer le code"
        OtpInlineField(
            value = uiState.code,
            onValueChange = { viewModel.onChangeCode(it) },
            error = uiState.codeError,
            cooldownSeconds = uiState.otpCooldownSeconds,
            otpEnabled = otpEnabled,
            canSendOtp = canSendOtp,
            onSendOtp = { viewModel.register() },
            colorMode = colorMode
        )
    }
}

@Composable
private fun OtpInlineField(
    value: String,
    onValueChange: (String) -> Unit,
    error: String?,
    cooldownSeconds: Int,
    otpEnabled: Boolean,
    canSendOtp: Boolean,
    onSendOtp: () -> Unit,
    colorMode: ColorMode
) {
    val colors = AuthTheme.colors(colorMode)
    val isInCooldown = cooldownSeconds > 0

    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .borderRadius(12.px)
                .border(2.px, LineStyle.Solid, if (error != null) colors.error else colors.border)
                .backgroundColor(colors.inputBg),
            verticalAlignment = Alignment.CenterVertically
        ) {
            // Champ code — désactivé si OTP pas encore envoyé
            Input(type = InputType.Text, attrs = {
                value(value)
                onInput { if (otpEnabled) onValueChange(it.value.filter { c -> c.isDigit() }.take(6)) }
                attr("placeholder", if (otpEnabled) "Code à 6 chiffres" else "Envoie le code d'abord")
                attr("maxlength", "6")
                attr("inputmode", "numeric")
                if (!otpEnabled) attr("disabled", "true")
                style {
                    property("background", "transparent")
                    property("border", "none")
                    property("outline", "none")
                    property("color", colors.onBackground.toString())
                    property("flex", "1")
                    property("font-size", "14px")
                    property("padding", "0 14px")
                    property("height", "48px")
                    property("width", "100%")
                    if (!otpEnabled) property("opacity", "0.45")
                    if (!otpEnabled) property("cursor", "not-allowed")
                }
            })

            Box(modifier = Modifier.width(1.px).height(32.px).backgroundColor(colors.borderLight))

            // Bouton Envoyer / Renvoyer
            Box(
                modifier = Modifier
                    .padding(leftRight = 14.px, topBottom = 12.px)
                    .cursor(if (canSendOtp && !isInCooldown) Cursor.Pointer else Cursor.NotAllowed)
                    .styleModifier { property("flex-shrink", "0") }
                    .onClick { if (canSendOtp && !isInCooldown) onSendOtp() },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    when {
                        isInCooldown -> "Renvoyer (${cooldownSeconds}s)"
                        otpEnabled   -> "Renvoyer"
                        else         -> "Envoyer le code"
                    },
                    modifier = Modifier
                        .fontSize(AuthTypography.tiny)
                        .fontWeight(FontWeight.SemiBold)
                        .color(if (canSendOtp && !isInCooldown) colors.primary else colors.mutedText)
                        .styleModifier { property("white-space", "nowrap") }
                )
            }
        }

        error?.let {
            SpanText(it, modifier = Modifier.color(colors.error).fontSize(AuthTypography.tiny).padding(top = 6.px, left = 12.px))
        }
    }
}